export function pluralize(input: string): string {
  if (input.endsWith('s') || input.endsWith('ch')) {
    return `${input}es`;
  }

  if (input.endsWith('y')) {
    return `${input.substr(0, input.length - 1)}ies`;
  }

  return `${input}s`;
}
